import { lowerCase } from 'lodash';

// Function except the string
// make it lowercase and replace underscore or camel cases
export const textFormatter = (sourceString: string | undefined) => {
  if (typeof sourceString === 'undefined') return '-';
  const lowerCaseStr =
    sourceString?.includes('-') || sourceString?.includes('.')
      ? sourceString?.trim()?.toLowerCase()
      : lowerCase(sourceString);

  return lowerCaseStr;
};
